exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#rows[data-v-7971599a]{\n    color: black;\n}\n.tableHistory>thead>tr[data-v-7971599a]{\n    background: #1C869A;\n    color: white;\n}\n", ""]);

// exports
